import type { FaireProductEntity } from "../../entity_types/product";

export const p_63fda9xzy8: FaireProductEntity = {
  token: "p_63fda9xzy8",
  type: "product",
  name: "Eva Maxi Dress - Khaki Green",
  brandToken: "b_2zdmtoaf",
  brandName: "The Handloom",
  imageUrl:
    "https://cdn.faire.com/fastly/3bbbc899f4b751b11215f28195b4fa168143a8d54b4bd594e3d016efa8a277e2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0ecf1a044be431a99ee3d00c5bf7a67edd0ead0f02a67db496c2b7bf3e3f2c60.png",
    "https://cdn.faire.com/fastly/ad6d05304c6c164a1e7c7f4a4c238fe3009e69485af430ab95fb0260ee37cb17.png",
    "https://cdn.faire.com/fastly/f9e0c26ff97cb6245d9551d14695c0d92ab1cee1ebad6054063563ea1626fd03.png",
    "https://cdn.faire.com/fastly/1b0b054c296384274bfdf997042a199e3e37b297fe6c3af044befce83565115b.jpeg",
    "https://cdn.faire.com/fastly/9a16aef5c8d26c2ed98bd9c81c276911f2f0dc8d28e99b22f7e1e757ad81124a.jpeg",
    "https://cdn.faire.com/fastly/d810c83c298e31508ffc372c8fbe53cc6bfd113076fc4671ecade26256a99cac.jpeg",
    "https://cdn.faire.com/fastly/62f14b9c6d85806399c1ad6c4faee27e8deec5216cbb9f4554c5f07105405c46.jpeg",
    "https://cdn.faire.com/fastly/419605d2e0c188a924d537720f98b836d39c133d16b94850d898678cd68b096b.jpeg",
    "https://cdn.faire.com/fastly/e64f5215321d797c29e55396bfa1b03f3e13e20ce138baff36ca52520c2817e6.jpeg",
    "https://cdn.faire.com/fastly/4d802393c468df48680f15eb0a70fc60fa9f4908b3ca5e6061f62b9e47d143a8.jpeg",
    "https://cdn.faire.com/fastly/a69715da7231fc0dad5ce717028fcb07ba030aa34c1bb8b896e7afeb06299501.jpeg",
  ],
  priceDollars: 84,
  description:
    "Designed to bring a statement to your summer, the Eva Maxi Dress Khaki Green features a slim fit style with a maxi hemline and V shaped neckline for a clean and streamlined silhouette. Crafted from 100% Turkish Cotton, the Eva Maxi Dress Khaki Green cascades along the body with stitch detail which accents movement on the fabric. Made for slipping on with ease, The Eva Maxi Dress Khaki Green is a minimalist elegant favorite piece.\n\n- 100% Turkish thick cotton, upper body\n",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:57.170Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
